module.exports = __webpack_public_path__ + "assets/img/27_1575.0cbd7a3c.jpg";